export default __webpack_public_path__ + "86b18cc47b14456ba6df2296b846e445.png";